import { t } from '@transifex/native';
import type { ChangeEvent, JSX } from 'react';
import { Fragment } from 'react';

import useMixedState from 'pkg/hooks/useMixedState';

import PasswordField from 'components/form/inputs/create_password/PasswordField';
import { Group } from 'components/form/inputs/group';

interface PasswordStateProps {
	password: string;
	confirmPassword: string;
}

/**
 * CreatePassword component
 *
 * Renders a password creation form with validation to ensure the password and confirmation match.
 * Utilizes the PasswordField component and organizes inputs within Group components.
 */

export function CreatePassword(): JSX.Element {
	const [passwordState, setPasswordState] = useMixedState<PasswordStateProps>({
		password: '',
		confirmPassword: '',
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
		setPasswordState({
			[e.target.name]: e.target.value,
		});

	const validate = () => {
		if (passwordState.password !== passwordState.confirmPassword) {
			return false;
		}

		return true;
	};

	return (
		<Fragment>
			<Group label={t('Pick a password')}>
				<PasswordField
					name="password"
					value={passwordState['password']}
					onChange={handleChange}
					validate={validate}
				/>
			</Group>
			<Group label={t('Confirm password')}>
				<PasswordField
					name="confirmPassword"
					value={passwordState['confirmPassword']}
					onChange={handleChange}
					validate={validate}
				/>
			</Group>
		</Fragment>
	);
}
